import { Page, Content } from '@backstage/core-components';
import {
  HomePageCompanyLogo,
  HomePageStarredEntities,
  HomePageToolkit,
  CustomHomepageGrid,
  HomePageRandomJoke,
  HomePageTopVisited,
  HomePageRecentlyVisited,
} from '@backstage/plugin-home';
import { HomePageSearchBar } from '@backstage/plugin-search';
import { Grid } from '@material-ui/core';
import { tools, useLogoStyles } from './shared';
import { HomePageXkcdComic } from 'backstage-plugin-xkcd';
import LogoFull from '../Root/LogoFull';

import {
  AzureHomePrsCard,
  AzureReviewPrsCard,
} from '@internal/backstage-plugin-azure-home-prs';
import {
  HomePageRequestedReviewsCard,
  HomePageYourOpenPullRequestsCard,
} from '@roadiehq/backstage-plugin-github-pull-requests';
import { FeatureFlagged } from '@backstage/core-app-api';

const defaultConfig = [
  {
    component: 'HomePageSearchBar',
    x: 0,
    y: 0,
    width: 24,
    height: 2,
  },
  {
    component: 'HomePageRecentlyVisited',
    x: 0,
    y: 1,
    width: 4,
    height: 4,
  },
  {
    component: 'HomePageTopVisited',
    x: 10,
    y: 1,
    width: 4,
    height: 4,
  },
  {
    component: 'HomePageStarredEntities',
    x: 4,
    y: 1,
    width: 4,
    height: 4,
  },
  {
    component: 'HomePageToolkit',
    x: 10,
    y: 2,
    width: 4,
    height: 4,
  },
  {
    component: 'XkcdComicCard',
    x: 0,
    y: 2,
    width: 6,
    height: 10,
  },
];

export const CustomizableHomePage = () => {
  const { svg, path, container } = useLogoStyles();

  return (
    <Page themeId="home">
      <Content>
        <Grid container justifyContent="center">
          <HomePageCompanyLogo
            className={container}
            logo={<LogoFull classes={{ svg, path }} />}
          />
        </Grid>

        <CustomHomepageGrid config={defaultConfig}>
          <HomePageSearchBar />
          <HomePageRecentlyVisited />
          <HomePageTopVisited />
          <HomePageToolkit tools={tools} />
          <HomePageStarredEntities />
          <HomePageRandomJoke />
          <HomePageXkcdComic />
          <FeatureFlagged with="ado-pull-requests">
            <AzureHomePrsCard />
            <AzureReviewPrsCard />
          </FeatureFlagged>
          <FeatureFlagged with="github-pull-requests">
            <HomePageRequestedReviewsCard />
            <HomePageYourOpenPullRequestsCard />
          </FeatureFlagged>
        </CustomHomepageGrid>
      </Content>
    </Page>
  );
};
